/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
  Badge, ICON_MAP_MARKER, ICON_PHONE, Symbol,
} from '@doveit/lego';
import React, { FunctionComponent } from 'react';
import Link from 'next/link';
import * as styles from './AgencyCard.style';
import { OFFICE_BUILDING_MARKER_OUTLINE } from '../../themes/icons';
import { URLObject } from '../../utils/links';
import AgentCard, { AgentCardProps } from '../agent-card/AgentCard';

export interface AgencyCardProps {
  name: string,
  address: string,
  phoneNumber?: string,
  openingHours?: string[],
  picture?: string,
  urlObject?: URLObject,
  franchising?: boolean,
  agents?: Omit<AgentCardProps, 'urlObject'>[],
  onClick?: VoidFunction,
}

const AgencyCard: FunctionComponent<AgencyCardProps> = ({
  name,
  address,
  phoneNumber,
  picture,
  urlObject,
  franchising = false,
  openingHours,
  agents = [],
  onClick,
}) => (
  <article
    css={styles.base}
    onClick={onClick}
  >
    <div css={styles.primary}>
      <div
        css={styles.picture}
        $pictureURL={picture}
      >
        {!picture && (
          <Symbol
            path={OFFICE_BUILDING_MARKER_OUTLINE}
            size={64}
          />
        )}
      </div>
      <div css={styles.info}>
        <div css={styles.name}>
          {urlObject ? (
            <Link
              href={urlObject.url}
              as={urlObject.as}
            >
              {name}
            </Link>
          ) : name}
        </div>
        <div css={styles.detail}>
          <Symbol
            path={ICON_MAP_MARKER}
            size={20}
          />
          {address}
        </div>
        {phoneNumber && (
          <div css={styles.detail}>
            <Symbol
              path={ICON_PHONE}
              size={20}
            />
            {phoneNumber}
          </div>
        )}
        {openingHours?.length > 0 && (
          <div css={styles.openingHours}>
            {openingHours.map((openingSlot) => (
              <div key={openingSlot}>
                {openingSlot}
              </div>
            ))}
          </div>
        )}
        {franchising && (
          <div css={styles.badge}>
            <Badge text="Franchising" />
          </div>
        )}
      </div>
    </div>
    {agents.length > 0 && (
      <div css={styles.agents}>
        {agents.slice(0, 3).map((broker) => (
          <AgentCard {...broker} />
        ))}
      </div>
    )}
  </article>
);

export default AgencyCard;
